import { render, staticRenderFns } from "./TermsOfServiceLink.vue?vue&type=template&id=6a127a58"
import script from "./TermsOfServiceLink.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports